import { PERMISSIONS } from "@/services/permission"

const allProjectViewPermissions = [
  PERMISSIONS.VIEW_ASSIGNED_PROJECT_GENERAL,
  PERMISSIONS.VIEW_ASSIGNED_PROJECT_HOURLYWAGEREPORT,
  PERMISSIONS.VIEW_ASSIGNED_PROJECT_CONSTRUCTIONREPORT,
  PERMISSIONS.VIEW_ASSIGNED_PROJECT_CONTACT,
  PERMISSIONS.VIEW_ASSIGNED_PROJECT_MACHINE,
  PERMISSIONS.VIEW_ASSIGNED_PROJECT_MATERIAL,
  PERMISSIONS.VIEW_ASSIGNED_PROJECT_ADDITIONAL_EFFORT,
  PERMISSIONS.VIEW_ASSIGNED_PROJECT_CATEGORY,
  PERMISSIONS.VIEW_ASSIGNED_PROJECT_USER,
  PERMISSIONS.VIEW_ASSIGNED_PROJECT_USERPOSITION,
  PERMISSIONS.VIEW_ASSIGNED_PROJECT_FILE,
  PERMISSIONS.VIEW_ASSIGNED_PROJECT_SETTINGS,
  PERMISSIONS.VIEW_ASSIGNED_PROJECT_HOURLYWAGEINVOICE,
  PERMISSIONS.VIEW_FOREIGN_PROJECT_GENERAL,
  PERMISSIONS.VIEW_FOREIGN_PROJECT_HOURLYWAGEREPORT,
  PERMISSIONS.VIEW_FOREIGN_PROJECT_CONSTRUCTIONREPORT,
  PERMISSIONS.VIEW_FOREIGN_PROJECT_CONTACT,
  PERMISSIONS.VIEW_FOREIGN_PROJECT_MACHINE,
  PERMISSIONS.VIEW_FOREIGN_PROJECT_MATERIAL,
  PERMISSIONS.VIEW_FOREIGN_PROJECT_ADDITIONAL_EFFORT,
  PERMISSIONS.VIEW_FOREIGN_PROJECT_CATEGORY,
  PERMISSIONS.VIEW_FOREIGN_PROJECT_USER,
  PERMISSIONS.VIEW_FOREIGN_PROJECT_USERPOSITION,
  PERMISSIONS.VIEW_FOREIGN_PROJECT_FILE,
  PERMISSIONS.VIEW_FOREIGN_PROJECT_SETTINGS,
  PERMISSIONS.VIEW_FOREIGN_PROJECT_HOURLYWAGEINVOICE,
]

// Cost pages expose wage rates and purchase prices, so they are gated by the dedicated
// costs permission instead of the general project view permissions.
const projectCostsPermissions = [PERMISSIONS.VIEW_ASSIGNED_PROJECT_COSTS, PERMISSIONS.VIEW_FOREIGN_PROJECT_COSTS]

export default [
  {
    path: "/project/list",
    name: "ProjectOverview",
    component: () => import("@/views/project/ProjectOverview"),
    meta: {
      title: "nav.project.overview",
      requiresAuth: true,
      requiresPermissions: allProjectViewPermissions,
    },
  },
  {
    path: "/project/create",
    name: "ProjectCreate",
    component: () => import("@/views/project/ProjectCreate"),
    meta: {
      title: "project.create.title",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.EDIT_ASSIGNED_PROJECT_GENERAL, PERMISSIONS.EDIT_FOREIGN_PROJECT_GENERAL],
    },
  },
  {
    path: "/project/costs",
    name: "ProjectCosts",
    component: () => import("@/views/project/ProjectCostsTimeline.vue"),
    meta: {
      title: "nav.project.costs",
      requiresAuth: true,
      requiresPermissions: projectCostsPermissions,
    },
  },
  {
    path: "/project/:projectId/costs",
    name: "ProjectCostsForOne",
    props: true,
    component: () => import("@/views/project/ProjectCostsTimeline.vue"),
    meta: {
      title: "nav.project.costs",
      requiresAuth: true,
      requiresPermissions: projectCostsPermissions,
    },
  },
  {
    path: "/project/:projectId/constructionreport/:crId/costs",
    name: "ConstructionReportCosts",
    props: true,
    component: () => import("@/views/project/ConstructionReportCostsPage.vue"),
    meta: {
      title: "project.costs.construction_report_costs.title",
      requiresAuth: true,
      requiresPermissions: projectCostsPermissions,
    },
  },
  {
    path: "/project/:projectId/hourlywagereport/:hwrId/costs",
    name: "HourlyWageReportCosts",
    props: true,
    component: () => import("@/views/project/HourlyWageReportCostsPage.vue"),
    meta: {
      title: "project.costs.hourly_wage_report_costs.title",
      requiresAuth: true,
      requiresPermissions: projectCostsPermissions,
    },
  },
  {
    path: "/project/:projectId",
    name: "ProjectDetail",
    props: true,
    component: () => import("@/views/project/ProjectDetail"),
    meta: {
      title: "nav.project.overview",
      requiresAuth: true,
      requiresPermissions: allProjectViewPermissions,
    },
  },
]
